import React from 'react';

export const Page404 = () => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        width: '100%',
        color: '#fff',
      }}
    >
      Page404
    </div>
  );
};
